import {
  MediaLibCategoryEnum,
  useMediaLibUploadingStore,
} from "@editor/modules/media-lib";
import { useMemo } from "react";

interface IProps {
  category: MediaLibCategoryEnum;
  selectedFolderId: string | null;
}

export const useMediaLibRevelantUploadingFiles = ({
  category,
  selectedFolderId,
}: IProps) => {
  const allUploadingFiles = useMediaLibUploadingStore((s) => s.uploadingFiles);

  return useMemo(() => {
    return allUploadingFiles.filter(
      (el) =>
        (!el.folderId || el.folderId === selectedFolderId) &&
        (el.type === category ||
          [
            MediaLibCategoryEnum.AllFiles,
            MediaLibCategoryEnum.BrandAssets,
          ].includes(category)),
    );
  }, [allUploadingFiles, category, selectedFolderId]);
};
